import { WATERFALL_MOUNT_MAX_DIRECT_MATCHES } from 'components/app/ProviderSearch/constants'
import { RouterFilters } from 'dataSource/ProviderSearch'

export const FILTER_NUDGE_QUESTIONS = {
  SPECIALTY: 'specialty',
  GENDER: 'gender',
  AGE: 'age',
} as const

export type FilterNudgeQuestion = typeof FILTER_NUDGE_QUESTIONS[keyof typeof FILTER_NUDGE_QUESTIONS]

export const FILTER_NUDGE_QUESTION_ORDER: FilterNudgeQuestion[] = [
  FILTER_NUDGE_QUESTIONS.SPECIALTY,
  FILTER_NUDGE_QUESTIONS.GENDER,
  FILTER_NUDGE_QUESTIONS.AGE,
]

export const FILTER_NUDGE_ROUTER_FILTERS: Record<
  FilterNudgeQuestion,
  RouterFilters
> = {
  [FILTER_NUDGE_QUESTIONS.SPECIALTY]: RouterFilters.AREA_OF_CONCERN,
  [FILTER_NUDGE_QUESTIONS.GENDER]: RouterFilters.GENDER,
  [FILTER_NUDGE_QUESTIONS.AGE]: RouterFilters.CLIENT_AGE_GROUP,
}

export const FILTER_NUDGE_HEADINGS: Record<FilterNudgeQuestion, string> = {
  [FILTER_NUDGE_QUESTIONS.SPECIALTY]: 'What do you need help with?',
  [FILTER_NUDGE_QUESTIONS.GENDER]: "Any preference for your provider's gender?",
  [FILTER_NUDGE_QUESTIONS.AGE]: "What's the patient's age?",
}

export const FILTER_NUDGE_SUBTEXTS: Partial<
  Record<FilterNudgeQuestion, string>
> = {
  [FILTER_NUDGE_QUESTIONS.AGE]:
    "We'll match you with providers who see this age group.",
}

export const FILTER_NUDGE_EYEBROW = 'Narrow your results'

export const FILTER_NUDGE_HEADING_ID = 'filter-nudge-heading'

export const FILTER_NUDGE_SEE_ALL_LABEL = 'See all'

/** Stored ages include "years old"; chip labels use "yrs". */
export const FILTER_NUDGE_AGE_VALUE_SUFFIX = /\s*years old$/i
export const FILTER_NUDGE_AGE_LABEL_SUFFIX = ' yrs'

/** Insert between results 4 and 5. */
export const FILTER_NUDGE_AFTER_INDEX = 3

/** Share the waterfall threshold to avoid showing both experiences. */
export const FILTER_NUDGE_MIN_TOTAL_RESULTS = WATERFALL_MOUNT_MAX_DIRECT_MATCHES

export interface FilterNudgeChipConfig {
  label: string
  /** `global_filters.value`; chips are matched to the state's options by this. */
  value: string
  icon: string
}

/** Pending the final cross-state specialty list from Data. */
export const FILTER_NUDGE_SPECIALTY_CHIPS: FilterNudgeChipConfig[] = [
  { label: 'ADHD', value: 'ADHD', icon: '/icons/specialty-adhd.svg' },
  { label: 'Anxiety', value: 'Anxiety', icon: '/icons/specialty-anxiety.svg' },
  {
    label: 'Depression',
    value: 'Depression',
    icon: '/icons/specialty-depression.svg',
  },
  {
    label: 'Grief or loss',
    value: 'Grief',
    icon: '/icons/specialty-grief.svg',
  },
  {
    label: 'Relationships',
    value: 'Relationships',
    icon: '/icons/specialty-relationships.svg',
  },
  {
    label: 'Trauma or PTSD',
    value: 'Trauma / PTSD',
    icon: '/icons/specialty-trauma.svg',
  },
]

export const FILTER_NUDGE_GENDER_CHIPS: FilterNudgeChipConfig[] = [
  {
    label: 'Female',
    value: 'Female',
    icon: '/icons/gender-female-with-bg.svg',
  },
  { label: 'Male', value: 'Male', icon: '/icons/gender-male-with-bg.svg' },
  {
    label: 'Transgender',
    value: 'Transgender',
    icon: '/icons/gender-transgender.svg',
  },
  {
    label: 'Non-binary or non-conforming',
    value: 'Non-binary/non-conforming',
    icon: '/icons/gender-nonbinary.svg',
  },
]

export const FILTER_NUDGE_AGE_ICONS: Partial<Record<string, string>> = {
  '0-5': '/images/agegroup1.svg',
  '6-10': '/images/agegroup2.svg',
  '11-13': '/images/agegroup3.svg',
  '14-17': '/images/agegroup4.svg',
  '18-64': '/images/agegroup5.svg',
  '65+': '/images/agegroup6.svg',
}
